import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MODULE_TYPES } from '@ohif/core';
import filesToStudies from './filesToStudies';
import { extensionManager } from '../../App.tsx';
import { ProgressBar } from 'primereact/progressbar';
import classNames from 'classnames';

function Local() {
  const navigate = useNavigate();
  const [value, setValue] = useState<number>(0);
  // Initializing the dicom local dataSource
  const dataSourceModules = extensionManager.modules[MODULE_TYPES.DATA_SOURCE];
  const localDataSources = dataSourceModules.reduce((acc, curr) => {
    const mods = [];
    curr.module.forEach(mod => {
      if (mod.type === 'localApi') {
        mods.push(mod);
      }
    });
    return acc.concat(mods);
  }, []);

  const firstLocalDataSource = localDataSources[0];
  const dataSource = firstLocalDataSource.createDataSource({});

  const onDrop = async acceptedFiles => {
    const studies = await filesToStudies(acceptedFiles, dataSource);
    // Todo: navigate to work list and let user select a mode
    const query = new URLSearchParams();
    studies.forEach(id => query.append('StudyInstanceUIDs', id));
    navigate(`/viewer/dicomlocal?${decodeURIComponent(query.toString())}`);
  };

  //IMPLEMENTADO
  let countProgress = 0;

  const onDropMetadata = acceptedFiles => {
    const studies = filesToStudies(acceptedFiles);
    const query = new URLSearchParams();
    //const studies = ['1.3.12.2.1107.5.2.60.209203.30000024020514252998300000204'];
    studies.forEach(id => query.append('StudyInstanceUIDs', id));
    navigate(`/viewer/dicomlocal?${decodeURIComponent(query.toString())}`);
  };

  function directDownloadToBlob() {
    const divider = 10;
    let blobArr = [];
    const urlDownloadMetadata = "http://192.168.200.102:9000/studies/1.3.12.2.1107.5.2.60.209203.30000024020514252998300000204/series/1.3.12.2.1107.5.2.60.209203.30000024020514252998300000175/instances/1.3.12.2.1107.5.2.60.209203.30000024020514252998300000131/metadata";
    var postData = new FormData();
    var xhr = new XMLHttpRequest();
    xhr.open('GET', urlDownloadMetadata, true);
    xhr.responseType = 'json';
    xhr.onload = async function (event) {
      const eventTarget = event.target;
      if (eventTarget.status == 200) {
        const metadata = eventTarget.response;
        metadata.forEach(async metadata => {
          //var data = "text/json;" + encodeURIComponent(JSON.stringify(metadata));
          //var data = encodeURIComponent(JSON.parse(metadata));
          //const base64Response = await fetch(`data:application/json;base64,${window.btoa(data)}`);
          //const blob = await base64Response.blob();
          //var blob = await new Blob([metadata, { type: "text/json" }]);
          //window.metadata = metadata;
          //const base64Response = await fetch(`data:application/dcm;base64,${window.btoa(metadata)}`);

          const base64Response = await fetch(`data:application/dcm;base64,${window.btoa(metadata)}`);
          const blob = base64Response.blob();
          blobArr.push(blob);
        });
        countProgress = countProgress + divider;
        setValue((countProgress));
        //if (index === divider)
        window.metadata = blobArr;
        onDropMetadata(blobArr);
      }
    }.bind(this)
    xhr.send(postData);

  }

  function loadBinaryResource() {
    if (window.loadImagesStart)
      return;
    const service = `${window.config.dataSources[0].configuration['wadoRoot']}/studies`;
    const studyUId = window.location.search.replace('?', '').trim();
    let blobArr = [];
    const divider = 10;
    window.loadImagesStart = true;
    for (let index = 1; index <= divider; index++) {
      const urlApi = service + `/studyuid/${studyUId}/divider/${divider}/index/${index}`;
      var postData = new FormData();
      var xhr = new XMLHttpRequest();
      xhr.open('GET', urlApi, true);
      xhr.responseType = 'json';
      xhr.onload = async function (event) {
        const eventTarget = event.target;
        if (eventTarget.status == 200) {
          const data = eventTarget.response;
          data.forEach(async fileB64 => {
            const base64Response = await fetch(`data:application/dcm;base64,${fileB64}`);
            const blob = await base64Response.blob();
            blobArr.push(blob);
          });
          countProgress = countProgress + divider;
          setValue((countProgress));
          if (index === divider)
            onDrop(blobArr);
        }
      }.bind(this)
      xhr.send(postData);
    }
  }
  loadBinaryResource();
  //directDownloadToBlob();

  // Set body style
  useEffect(() => {
    document.body.classList.add('bg-black');
    return () => {
      document.body.classList.remove('bg-black');
    };
  }, []);


  return (
    <div
      className={classNames('absolute z-50 top-0 left-0 flex flex-col items-center justify-center space-y-5', 'w-full h-full')}
    >
      <img src="/layout/logo.png" alt="" style={{ maxHeight: '40px' }} />
      <div className="loading" style={{ height: 'auto', width: '20em' }}>
        <ProgressBar mode={'determinate'} value={value} style={{ height: '30px' }}></ProgressBar>
        <div style={{ backgroundColor: '#040d19', textAlign: 'center', color: '#8dd0ff', padding: '5px', fontSize: '12px' }}>
          {value < 100 ? "Aguarde. Obtendo imagens dicom..." : "Aguarde. Finalizando..."}
        </div>
      </div>
    </div>
  );
}

export default Local;
